// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./MarkerCluster.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("5f0543e4", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet.markercluster/dist/MarkerCluster.css
// module id = 127
// module chunks = 0